import { FC } from 'react';
import Modal from 'react-modal';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import MakeOfferConfirmModalContent from './MakeOfferConfirmModalContent/MakeOfferConfirmModalContent';

interface Props {
  modalIsOpen: boolean;
  handleClose: (show: boolean) => void;
  candidatePositionStatusId: number;
  candidateId: number;
}

const MakeOfferConfirmModal: FC<Props> = ({
  modalIsOpen,
  handleClose,
  candidatePositionStatusId,
  candidateId,
}) => {
  Modal.setAppElement(document.getElementById('root') as HTMLElement);

  return (
    <ModalInTailwind isOpen={modalIsOpen} closeModal={() => handleClose(false)}>
      <MakeOfferConfirmModalContent
        handleClose={handleClose}
        candidatePositionStatusId={candidatePositionStatusId}
        candidateId={candidateId}
      />
    </ModalInTailwind>
  );
};

export default MakeOfferConfirmModal;
